// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__D8kU3","author":"Table_author__2bSHn","authorImage":"Table_authorImage__2jucc","unreadRow":"Table_unreadRow__2Zlpn"};